import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;
  width: 100vw;
  max-width: 1300px;
  margin: 0 auto 0;

  button {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    padding: 1rem 0;
    margin-top: -1rem;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    svg {
      margin-right: 8px;
    }
  }
`

export const ContentWrapper = styled.div`
  @media only screen and (min-width: 600px) {
    display: flex;
    align-items: flex-start;
  }
`

export const UpseelWrapper = styled.div`
  max-width: 830px;
  min-height: 120px;
  background-color: ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 10px;
  padding: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-around;

  margin-top: 2rem;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }

  p {
    font-size: 1rem;
    line-height: 140%;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
    font-weight: 400;
    max-width: 555px;
  }
`

export const BuyModule = styled.a`
  display: flex;
  align-items: center;

  max-heght: 40px;

  background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 4px;
  border: none;

  color: ${({ theme }) => `rgb(${theme.background.high})`};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;

  padding: 8px 16px;

  margin-left: 16px;

  svg {
    margin-right: 0.4rem;
  }

  &:hover {
    color: ${({ theme }) => `rgb(${theme.background.high})`};
  }
`

export const CourseTitle = styled.div`
  max-width: 555px;

  h2 {
    font-size: 1.625rem;
    line-height: 2.3125rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    margin-top: 0px;
  }

  a,
  p {
    font-size: 1rem;
    line-height: 140%;
  }

  p {
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    font-weight: 500;
  }

  a {
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    font-weight: 600;
  }
`

export const ImageWrapper = styled.div`
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 4px;
  max-width: 120px;
  padding: 0.5rem;
  margin-right: 3rem;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 6.375rem;
    width: 6.375rem;

    object-fit: contain;
  }
`

export const ProgressWrapper = styled.div`
  background: ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 10px;
  padding: 1rem;
  margin: 1.9rem 0;
  max-width: 870px;

  span {
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    margin-bottom: 0.9rem;
  }
`
